export default __webpack_public_path__ + "static/media/nse-231447119991649442-6fa8c250-1c68-43f8-bc41-45ce982583ee.26d2d783.jpg";